import { render, staticRenderFns } from "./PublicCGU.vue?vue&type=template&id=6389ba6c&"
import script from "./PublicCGU.vue?vue&type=script&lang=js&"
export * from "./PublicCGU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports